var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.showBar,
          expression: "showBar",
        },
      ],
      staticClass: "ds-control ds-button-bar",
      class: _vm.getCss,
    },
    [
      _c(
        "div",
        { staticClass: "bar-wrap" },
        [
          _vm.isDesign && _vm.showButtonsReal.length == 0
            ? [
                _c(
                  "div",
                  {
                    staticStyle: {
                      "text-align": "center",
                      "background-color": "#fff",
                      width: "100%",
                      padding: "5px 0px",
                      "font-style": "italic",
                      color: "#c0c0c0",
                    },
                  },
                  [_vm._v(" 未配置按钮 ")]
                ),
              ]
            : _vm._e(),
          _vm._l(_vm.showButtonsReal, function (button, $index) {
            return [
              _vm.hasChild(button)
                ? [
                    _c("MenuButton", {
                      key: "children_button_popover_" + $index,
                      attrs: { button: button, owner: _vm._self },
                    }),
                  ]
                : button.isUpload
                ? [
                    _vm.showUploadbutton(button)
                      ? _c("UploadButton", {
                          key: "upload_button_" + $index,
                          attrs: { button: button, owner: _vm._self },
                        })
                      : _c(
                          "DsfButton",
                          {
                            key: "upload_button_template_" + $index,
                            style: button.style,
                            attrs: {
                              icon: _vm.getIcon(button),
                              title: button.title,
                              disabled: button.disabled,
                              size: _vm.size,
                              type: button.type,
                              "btn-style": button.btnStyle,
                              "icon-position": button.iconPosition,
                              loading: button.loading,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.clickHandler(button, $event)
                              },
                            },
                          },
                          [_vm._v(" " + _vm._s(button.text) + " ")]
                        ),
                  ]
                : button.isLinkSend &&
                  button.isLinkSendFold &&
                  (button.actionName === "system_flow_send" ||
                    button.actionName === "system_batch_flow_send")
                ? [
                    _c("FlowButton", {
                      key: "morebutton_" + $index,
                      attrs: { button: button, owner: _vm._self },
                    }),
                  ]
                : [
                    _c(
                      "DsfButton",
                      {
                        key: "__" + $index,
                        style: button.style,
                        attrs: {
                          icon: _vm.getIcon(button),
                          title: button.title,
                          disabled: button.disabled,
                          size: _vm.size,
                          type: button.type,
                          "btn-style": button.btnStyle,
                          "icon-position": button.iconPosition,
                          loading: button.loading,
                        },
                        on: {
                          click: function ($event) {
                            return _vm.clickHandler(button, $event)
                          },
                        },
                      },
                      [_vm._v(" " + _vm._s(button.text) + " ")]
                    ),
                  ],
            ]
          }),
          _vm.moreButtonsReal.length
            ? _c("MoreButton", {
                ref: "morebutton",
                attrs: { owner: _vm._self, moreBtnColNum: _vm.moreBtnColNum },
                on: {
                  mousedown: function ($event) {
                    return _vm.moreButtonMouseDownHandler($event)
                  },
                },
              })
            : _vm._e(),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }